module.exports = __webpack_public_path__ + "static/media/film-production-grid-4.51763011.jpg";